
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26.015 32.689"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#004588"}},[_c('path',{attrs:{"data-name":"Pfad 482","d":"M13.008 32.689a1.374 1.374 0 01-.835-.285C10.139 30.837 0 22.582 0 13.692 0 5.886 5.592 0 13.008 0s13.007 5.886 13.007 13.692c0 8.892-10.14 17.147-12.172 18.712a1.377 1.377 0 01-.835.285zm0-31.319C6.373 1.37 1.37 6.67 1.37 13.693c0 8.248 9.7 16.131 11.638 17.627 1.943-1.5 11.638-9.376 11.638-17.627 0-7.026-5.003-12.324-11.638-12.324z"}}),_c('path',{attrs:{"data-name":"Pfad 483","d":"M10.269 20.538a.685.685 0 010-1.369h2.054v-7.531a.685.685 0 00-.685-.685h-1.369a.685.685 0 010-1.369h1.369a2.056 2.056 0 012.054 2.054v7.531h2.054a.685.685 0 110 1.369z"}}),_c('circle',{attrs:{"data-name":"Ellipse 31","cx":"1.027","cy":"1.027","r":"1.027","transform":"translate(11.98 6.161)"}})])])
          )
        }
      }
    